const routes = Object.freeze({
    ROOT: '/',
    LOGIN: '/login',
    LOGIN_CALLBACK: '/callback',
    SILENT_LOGIN_CALLBACK: '/silent-renew',
    LOGOUT: '/logout',
    ERROR_PAGE: '/error-page',
    EVIDENCE_BASED_PRACTICE: '/:ecrId/evidence-based-practice',
    NO_SKILL: '/no-skill',
    SKILL_LAUNCH: '/:ecrId/skill/:id',
    FAVORITES_CONTENT: '/:ecrId/favorites-content',
    SEARCH: '/:ecrId/search',
    HOME: '/:ecrId/home',
    PATIENT_EDUCATION: '/:ecrId/patient-education',
});

export default routes;
